import styled from 'styled-components';

export const PreloadImage = styled.img`
  position: absolute;
  left: -9999px;
  top: 0;
  width: 1px;
  height: 1px;
  opacity: 0;
  pointer-events: none;
`;

export const BannerImage = styled.img`
  width: 100%;
  height: auto;
  display: block;
`;
